<template>
    <CardDropdownSm :item="itemData">
        <template #icon>
            <component :is="icon" class="flex-shrink-0 h-9 py-2 ct-fg-4" />
        </template>
        <template #extra>
            <FormToggleSm v-model="tickerActive" />
        </template>
    </CardDropdownSm>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import { markRaw } from "vue";
import { PencilSquareIcon, TickerIcon } from "@easy/ui/icons";
import { CardDropdownSm } from "@easy/ui/cards";
import { FormToggleSm } from "@easy/ui/forms";
import { tickersService } from "@/apps/ticker/services/tickers.service";

export default {
    props: {
        item: Object,
    },
    emits: ["edit"],
    components: {
        CardDropdownSm,
        FormToggleSm,
    },
    data() {
        return {
            icons: tickersService.getIconsList(),
        };
    },
    computed: {
        ...mapState("ticker", ["events"]),
        tickerEvent() {
            return this.events.find((e) => e.code === this.item.code);
        },
        tickerText() {
            return this.tickerEvent?.text || this.item.description;
        },
        tickerIcon() {
            return this.tickerEvent && this.tickerEvent.icon
                ? this.tickerEvent.icon
                : this.item.icon;
        },
        icon() {
            if (!this.tickerIcon) return markRaw(TickerIcon);
            return markRaw(this.icons.find((i) => i.name === this.tickerIcon).icon);
        },
        tickerActive: {
            get() {
                return this.tickerEvent ? this.tickerEvent.active : false;
            },
            set(value) {
                this.createEventIfNotExist();
                if (!this.tickerEvent._created && !this.tickerEvent._deleted) {
                    this.tickerEvent._changed = true;
                }
                this.tickerEvent.active = value;
            },
        },
        itemData() {
            return {
                title: this.item.title,
                subtitle: "",
                actions: [
                    {
                        label: this.$t("shared.edit"),
                        icon: markRaw(PencilSquareIcon),
                        handler: () => {
                            this.$emit("edit");
                        },
                    },
                ],
            };
        },
    },
    methods: {
        ...mapMutations("ticker", ["addEvent"]),
        createEventIfNotExist() {
            if (!this.tickerEvent) {
                this.addEvent(this.item.code);
            }
        },
    },
};
</script>
